$(document).ready(function () {
  function updateProductList() {
    $('#ProductGridContainer .grid__item').each(function () {
      var $item = $(this);
      var brand = $item.data('brand');
      var use = $item.data('use');
      var use2 = $item.data('use2');
      var people = $item.data('people');

      // 選択された値を取得
      var selectedBrands = $('.search_use_menu input[name="brand"]:checked').map(function () {
        return $(this).val();
      }).get();

      var selectedUses = $('.search_use_menu input[name="use"]:checked').map(function () {
        return $(this).val();
      }).get();

      var selectedUse2s = $('.search_use_menu input[name="use2"]:checked').map(function () {
        return $(this).val();
      }).get();

      var selectedPeoples = $('.search_people_menu input[name="people"]:checked').map(function () {
        return $(this).val();
      }).get();

      // 絞り込み条件に合うかチェック
      var match = true;

      if (selectedBrands.length && !selectedBrands.includes(brand)) match = false;
      if (selectedUses.length && !selectedUses.includes(use)) match = false;
      if (selectedUse2s.length && !selectedUse2s.some(val => use2.includes(val))) match = false;
      if (selectedPeoples.length && !selectedPeoples.includes(people)) match = false;

      // 表示・非表示切り替え
      $item.toggle(match);
    });

    // 件数更新
    const count = $('#ProductGridContainer .grid__item:visible').length;
    $('#product-count').text(count);
  }

  // 初期表示
  updateProductList();

  // イベントバインド
  $('.search_use_menu input, .search_people_menu input').on('change', updateProductList);

  // タブ切替
  $('.search_target li').click(function () {
    $('.search_target li').removeClass('active');
    $(this).addClass('active');

    var target = $(this).data('target');
    $('.search_use').hide();
    $('#target-' + target).show();
  });
});
